import React, { FC } from 'react';

import { useRouter } from 'react-resource-router';

import { useHistory__UNSAFE, useParams } from 'src/router/hooks';

import SourceBrowser, { Params } from './source-browser';
import SourceSection from './source-section';

/* eslint @typescript-eslint/ban-types: "warn" */
const SourceBrowserWrapped: FC = () => {
  const [router] = useRouter();
  const history = useHistory__UNSAFE();
  const params = useParams<Params>();
  return (
    <SourceSection {...router} {...params} history={history}>
      <SourceBrowser {...router} {...params} history={history} />
    </SourceSection>
  );
};

export default SourceBrowserWrapped;
